import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useHistory } from "react-router-dom";
import { getDashboard } from '../../helpers/backend';


import ComponentsMantenimiento from '../../components/Common/ComponentsMantenimiento';

const Widget = props => {
    const history = useHistory()
    const user = JSON.parse(localStorage.getItem("user"));
    const groups =String(user.groups);

    const [dashboardList,  setDashboardList] = useState({})
    
        const getData = async () => {
            const response = await getDashboard();
            const data = response.data;
            setDashboardList(data)
        };

useEffect(() => {
    getData();
}, [])
const widget = [

    {
        id: 1,
        title:  groups === "Cliente" ? "Mi Perfil" : "Contactos",        
        count: '',
        icon: 'fas fa-user-tie fa-2x text-primary',
        path: '/contacts',
        color : "#efefe8"

  
    },
    {
        id: 2,
        title: 'Casos',
        count: '',
        icon: 'mdi mdi-badge-account-horizontal-outline  fa-2x text-success',
        path: '/casos',
        color : "#efefe8"
    

    },
    {
        id: 3,
        title: 'Cotizaciones (en Proceso)',
        count: '',
        icon: ' fas fa-folder-open fa-2x text-danger',
        path: '',
        color : "#efefe8"


    },

    groups.includes("SuperAdmin") ||  groups.includes("Supervisor") ?(

        {
            id: 4,
            title: 'Compras',
            count: '',
            icon: ' fa fa-shopping-cart fa-2x text-black',
            path: '/compras',
            color : "#efefe8"
    
    
        }
    ):[]
   
 
  
  

 

]
const redirect = (path) => {
    history.push(`${path}`)
  };

    return (
        <React.Fragment>

            <ComponentsMantenimiento
            dashboardList={dashboardList}
            >

            </ComponentsMantenimiento>
            <Row>
                {widget.map((item, key) => {
                 
                    return(


                    

                            <Col lg={3} key={key}>
                                <Card style={{cursor: 'pointer', height: '140px', background: item.color}} onClick={()=>redirect(item.path) }>
        
                                    <CardBody>
                                        <div className="float-end">
                                            <div className="avatar-sm mx-auto mb-4">
                                                <span className="avatar-title rounded-circle bg-light font-size-24">
                                                    <i className={item.icon}></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <p className=" text-uppercase fw-semibold font-size-18 ">{item.title}</p>
                                            <h3 className="mb-1 mt-1">
                                                <span className="counter-value " data-target="58425">
                                                    {item.count}
                                                </span></h3>
                                        </div>
        
                                    </CardBody>
                                </Card>
                            </Col>
                   
                        
                    )
                    })}
            </Row>
        </React.Fragment>
    );
}

export default Widget;